import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';

// react component for creating dynamic tables

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

// @material-ui/icons

import Style from "assets/jss/material-dashboard-pro-react/views/threadsStyle";
import loader from "assets/img/loader.gif";

import avatar from "assets/img/faces/user.png";
import DefaultProfile from "assets/img/default-avatar.png"
// Forms

// Firebase Redux Integration
function messageSort(a, b) {
  return a.createdAt - b.createdAt;
}

function ident(user) {
  return (user.firstName && user.firstName.trim().charAt(0)) + (user.lastName && user.lastName.trim().charAt(0));
}

const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class ThreadsMap extends React.Component {
  constructor(props) {
    super(props);

    this.scrollToBottom = this.scrollToBottom.bind(this)
  }


  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  }


  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }


  render() {
    const { classes, currentThread, user, users } = this.props
    console.log('classes', classes)
    return (
      <div style={{ marginLeft: "12%" }}>
        {
          currentThread ? (
            <div>
              {currentThread.messages && currentThread.messages.sort(messageSort).map((message, index) => {
                if (message.uid === user.id) {
                  return (
                    <div className={classes.userDiv} key={index}>
                      <GridContainer className={classes.userGridContainer}>
                        <GridItem className={classes.userGridItem} xs={9}>
                          <Card className={classes.userChatDiv}>
                            <CardBody>
                              <p className={classes.cardCategory}>
                                {message.message}
                              </p>
                            </CardBody>
                          </Card>
                        </GridItem>
                        <GridItem className={classes.userInfo} xs={2} >
                          {ident(user)}
                          <img className={classes.userImg} src={user.profileURL} alt="..." />
                        </GridItem>
                      </GridContainer>

                    </div>
                  )
                } else {
                  const sender = users.find(row => row.uid === message.uid);
                  const senderImage = sender && sender.profileURL ? sender.profileURL : DefaultProfile;
                  return (
                    <div className={classes.senderDiv} key={index}>
                      <GridContainer style={{ margin: "0 -9px" }}>
                        <GridItem className={classes.senderAvatarDiv} xs={2} >
                          {ident(sender)}
                          <img src={senderImage} className={classes.userImg} alt="..." />
                        </GridItem>
                        <GridItem xs={9}>
                          <Card className={classes.senderChatDiv}>
                            <CardBody>
                              <p className={classes.cardCategory}>
                                {message.message}
                              </p>
                            </CardBody>
                          </Card>
                        </GridItem>
                      </GridContainer>

                    </div>
                  )
                }
              })}
              <div style={{ float: "left", clear: "both" }}
                ref={(el) => { this.messagesEnd = el; }}>
              </div>
            </div>
          ) : (
              <div style={{ backgroundColor: "#F7F4F0", position: "absolute", width: "100%", height: "100%" }}>
                <img
                  style={{ margin: "65% 0% 0% 41%", position: "relative", width: "20%" }}
                  src={loader}
                  alt="..."
                />
              </div>)
        }
      </div>
    );

  }
}

const mapStateToProps = (state) => {
  return {
    users: state.user.users.dataRows,
    user: state.user.user,
    currentThread: state.threads.currentThread
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  //   console.log(ownProps)
  return {

  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Style)
)(ThreadsMap);

















// return (
//   <div className={classes.mainDivMargins}>
//     {currentThread && currentThread.messages.map((message, index) => {
//       if (message.uid === user.id) {
//         return (
//           <div key={index}>
//             <GridContainer >
//               <GridItem className={classes.senderAvatarDiv} xs={2} >

//                 <img src={user.profileURL || avatar} style={{ borderRadius: "50%", height: "50px" }} alt="..." />
//               </GridItem>
//               <GridItem xs={9}>
//                 <Card style={{ marginTop: "0px" }}>
//                   <CardBody>

//                     <p style={{ marginTop: "-10px", textAlign: "right" }} className={classes.cardCategory}>
//                       {message.message}
//                     </p>
//                   </CardBody>
//                 </Card>

//               </GridItem>
//             </GridContainer>
//           </div>
//         )
//       } else {
//         const sender = users.find(user => user.uid === message.uid) || {}
//         // console.log('sender', sender)
//         return (
//           <div key={index}>
//             <GridContainer style={{ padding: "0px 10px 0px 20px" }}>

//               <GridItem xs={9}>
//                 <Card style={{ marginTop: "0px" }}>
//                   <CardBody>

//                     <p style={{ marginTop: "-10px" }} className={classes.cardCategory}>
//                       {message.message}
//                     </p>
//                   </CardBody>
//                 </Card>
//                 <GridItem xs={2} >

//                   <img className={classes.userImg} src={sender.profileURL || avatar} alt="..." />
//                 </GridItem>

//               </GridItem>
//             </GridContainer>
//           </div>
//         )
//       }
//     })}
//     <div style={{ float: "left", clear: "both" }}
//       ref={(el) => { this.messagesEnd = el; }}>
//     </div>
//   </div>
// );